import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { PetitionBuilderService } from 'src/app/services/petition-builder.service';
import { getStepDetails } from '../../store/selectors/sub-task-details.selectors';
import { TaskStep } from 'src/app/data/models/task-step.model';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ImagilityBaseResponse } from '../../../../data/models/response.model';
import { NgForm } from '@angular/forms';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { map } from 'rxjs/internal/operators/map';
import { updatei140StepStatus } from '../../store/actions/step-status-update.actions';
import { StepStatusUpdatePayload } from '../../utility/services/stepStatusUpdate.service';
import { AppServicesLibraryService } from 'app-services-library';
import { loadSubTaskDetails } from '../../store/actions/sub-task-details.actions';


@Component({
  selector: 'app-mailing-address',
  templateUrl: './mailing-address.component.html',
  styleUrls: ['./mailing-address.component.scss']
})
export class MailingAddressComponent implements OnInit, OnDestroy {

  @Input()
  primaryData;

  @ViewChild('mailingAddressForm', { static: true }) mailingAddressForm: NgForm;
  inputData: any;
  mailingAddress: any;
  serviceCenterSelectedName: string;
  selectedServiceCenter: number;
  disabledControls: boolean;
  stepDetails: TaskStep;

  serviceCenters: any[] = [];   
  processingType: string;  // Regular or Premium
  serviceCenterId: any; // Selected Service Center Name ID
  visaType: string = 'H1-B'; // Assuming visaType is set like this, adjust if needed

  observableSubscription$ = new Subject();

  constructor(
    private store: Store<any>,
    private pbService: PetitionBuilderService,
    public dynamicDialogConfig: DynamicDialogConfig,
    private toastr: ToastrService,
    private stepStatusUpdatePayloadCostruction: StepStatusUpdatePayload,
    private appServicesLibraryService: AppServicesLibraryService
  ) {
    this.disabledControls = false;
    this.serviceCenterSelectedName = '-';
    this.selectedServiceCenter = 0;
    this.disabledControls = false;
    this.mailingAddress = [];
  }

  ngOnInit(): void {
    this.inputData = this.primaryData;

    
    this.store.pipe(select(getStepDetails, { id: this.dynamicDialogConfig.data.stepId }))
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((data: TaskStep) => {
        this.stepDetails = data;
        this.getMailingAddress();
        this.toggleControlsStatus();
      });

    this.mailingAddressForm.form.valueChanges.pipe(
      map(() => this.mailingAddressForm.dirty),
    ).pipe(takeUntil(this.observableSubscription$)).subscribe(dirty => {
      if (dirty) {
        this.store.dispatch(new MarkDirtyFormAction({
          dirty: true
        }));
      } else {
        this.store.dispatch(new MarkCleanFormAction({
          dirty: false
        }));
      }
    });
  }

  onRowSelect(event) {
    this.store.dispatch(new MarkDirtyFormAction({
      dirty: true
    }));
  }

  // Toggle controls status based on step status
  toggleControlsStatus() {
    this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
    // this.disabledControls = (this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === 'COMPLETE' ||
      // this.stepDetails.stepStatusDetails.stepStatusCode === 'SUBMIT');
  }

  getMailingAddress() {
    this.pbService.getServiceCenter(
      this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.i140CaseId)
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((response: ImagilityBaseResponse) => {
        if (response && response['data']) {
          this.mailingAddress = response['data'] as [];
          this.selectedServiceCenter = (this.mailingAddress as any[]).find(x => x['serviceCenters']['isSelected'] === true);
           //Load perviously selected Type and Center data
           const serviceCenters = response.data;           
           serviceCenters.forEach(center => {
             if (center.serviceCenters.isPremiumCenter === 1) {
               // If isPremiumCenter is 1, set processingType to 'premium'
               this.processingType = 'premium';
             } else {
               // Otherwise, set it to 'regular'
               this.processingType = 'regular';
             }
           })
           this.onChangeProcessingType();
        }
      });
  }

  postMailingAddress() {
    this.pbService.postServiceCenter(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.i140CaseId, this.selectedServiceCenter['serviceCenters'].id, this.serviceCenterId)    
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe(response => {
        this.toastr.success(response.message, 'Success');
        this.mailingAddressForm.resetForm();
        this.store.dispatch(loadSubTaskDetails({ taskId: this.stepDetails.taskId }));
        this.getMailingAddress();
      });
  }

  onChangeProcessingType(){
    this.serviceCenters = [];
    this.getServiceCenter();    
  }

  getServiceCenter() {    
    this.pbService.getImmiServiceCenters((this.processingType === 'regular') ? false : true, this.dynamicDialogConfig.data.taskTypeId).subscribe((data: Array<any>) => {
        this.serviceCenters = data;   
          if(this.mailingAddress){
            this.serviceCenterId = this.mailingAddress[0].serviceCenterNameId;
          }     
      });
  } 

  changeCenter(event: any) {    
    this.serviceCenterId = event.value;    
    this.pbService.getAddressFromCenter(this.dynamicDialogConfig.data.visatype, this.dynamicDialogConfig.data.caseType, this.dynamicDialogConfig.data.petitionerId, this.dynamicDialogConfig.data.taskTypeId, this.serviceCenterId).pipe(takeUntil(this.observableSubscription$))
      .subscribe((response: ImagilityBaseResponse) => {
        if (response && response['data']) {                      
          this.mailingAddress = this.transformData(response['data']);                 
          this.selectedServiceCenter = this.mailingAddress.find(x => x.serviceCenters.isSelected === true);         
        }else{
          this.mailingAddress = [];
          this.selectedServiceCenter = 0;
        }
      });
  }

  transformData(data: any[]): any[] {
    return data.map(item => ({
      serviceCenterName: item.serviceCenterName,
      serviceCenterNameId: item.serviceCenterNameId,
      serviceCenters: {
        createdBy: item.createdBy,
        modifiedBy: item.modifiedBy,
        id: item.id,
        serviceCenterName: item.serviceCenterName,
        serviceCenterNameId: item.serviceCenterNameId,
        isPremiumCenter: item.isPremiumCenter,
        attentionTo: item.attentionTo,
        addressLine1: item.addressLine1,
        addressLine2: item.addressLine2,
        postCode: item.postCode,
        countryCode: item.countryCode,
        stateProvinceCode: item.stateProvinceCode,
        stateProvinceName: item.stateProvinceName,
        city: item.city,
        shippingServiceType: item.shippingServiceType,
        isSelected: item.isSelected,
        taskTypeId: item.taskTypeId
      }
    }));
  }

  updateStepStatus(status) {
    this.store.dispatch(
      updatei140StepStatus({
        payload: this.stepStatusUpdatePayloadCostruction.payloadConstruction(this.stepDetails, status),
        subTaskId: this.stepDetails.taskId, actionCode: this.stepDetails.stepActionList[0].layoutCode
      }));
  }

  formatAddress(...args) {
    let fulladress = args[0] != null && args[0].length > 0 ? args[0] : '';
    fulladress += args[1] != null && args[1].length > 0 ? ', ' + args[1] : '';
    fulladress += args[2] != null && args[2].length > 0 ? ', ' + args[2] : '';
    fulladress += args[3] != null && args[3].length > 0 ? ', ' + args[3] : '';
    return fulladress;
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }

}
